import React, { Component } from "react";
import {    Button,  Modal } from "react-bootstrap";
import 'containers/common/Detail.css';



import BuildingNameList from "containers/property/BuildingNameList";



export default class BuildingNameModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
         
            isLoading: true
        };

        this.handleChange = this.handleChange.bind(this);
        //this.handleSubmit = this.handleSubmit.bind(this);
     
       
    }
    

    async componentDidMount() {
        console.log("In BuildingNameModal componentDidMount");
        if (!this.props.isAuthenticated) { // if false
            return;
        }

        if (!this.props.show) {
            return null;
        }

           
    }

    componentWillUnmount() {
        this.setState({ entities: [] });
    }

    handleChange = event => {
        console.log("Inside handleChange");
        this.setState({
            [event.target.id]: event.target.value
        });

    }

    

    renderBuildingNames() {
        return (
            
            <Modal
                show={this.props.show}
                onHide={this.props.toggleBuildingNameModal}
                dialogClassName="modal-90w"
                >
                <Modal.Header closeButton>
                    <Modal.Title>Building Names</Modal.Title>
                </Modal.Header>
                <Modal.Body>
           
               
                

              

                        <BuildingNameList
                            filter={this.props.filter}
                            isAuthenticated={this.props.isAuthenticated}
                            isLoading={this.state.isLoading}
                            controlType="table" 
                            saveForm={this.props.saveForm}
                            user={this.props.user}
                            data={this.props.data}
                            updateTableState={this.props.updateTableState}
                            saveRecord={this.props.saveRecord}
                        deleteRecord={this.props.deleteRecord}
                        validateRelatedRecord={this.props.validateRelatedRecord}
                        />

                  
          
                    </Modal.Body>
            </Modal>
        );
    }
    
    


    render() {
        return (

            <div className="BuildingNameEdit">
                {this.props.isAuthenticated ? this.renderBuildingNames() : console.log("error)")}
            </div>
        );
    }
}
